import { Component, OnInit } from '@angular/core';
import { IonFab, LoadingController, ModalController, NavParams } from '@ionic/angular';
import { element } from '@angular/core/src/render3';
import utf8 from 'utf8';
import { DocumentService } from 'src/services/document.service';

@Component({
    selector: 'modal-detalhe-medicamento',
    templateUrl: 'modal-detalhe-medicamento-component.html',
    styleUrls: ['modal-detalhe-medicamento-component.scss']
})

export class ModalDetalheMedicamentoComponent implements OnInit {

    medicamento: any;
    detalhe: any;
    list: any;

    constructor(private modalController: ModalController,
                private navParams: NavParams,
                private document: DocumentService,
                private loadingCtrl: LoadingController) {
        this.medicamento = this.navParams.get('medicamento');
    }

    ngOnInit() {
        this.getDetalhe(this.medicamento);
    }

    getTitle() {
        return 'Medicamentos';
    }

    getIconTipo() {
        return '/assets/imgs/icons/img-icon-medicamento.png';
    }

    fechar() {
        this.modalController.dismiss();
    }

    async getDetalhe(medicamento) {
        const detalhe = medicamento;
        console.log(detalhe);
        this.list = detalhe;
    }
}
